import { createFileRoute } from "@tanstack/react-router";

import { PlaceholderPage } from "@/components/PlaceholderPage";

export const Route = createFileRoute("/app/$storeId/error")({
    component: RouteComponent,
});

function RouteComponent() {
    return <PlaceholderPage title="Admin Error" />;
}
